// ---------------------------------------------------------------------------
// The bot roster — every bot Play the Bot has run, by name and version
// ---------------------------------------------------------------------------
//
// Naming: a biblical first name, "Bot", and a version number, the first
// names in alphabetical order by version (Abel, Boaz, Caleb, …). v7 is the
// exception, Gary (Francis's choice, in G's place); next up: Hannah, Isaac,
// …. A new bot gets the next version and name, and
// its uid is `bot:<name>-v<version>`; the archive stamps every war with
// player 2's uid (and, since 2026-10-02, the build's commit), so a war can
// always be traced to the bot that played it. docs/BOTS.md has the same list
// with how each was measured.
//
// Bots before v6 kept the uid they were deployed with, and two shared one
// (v3 and v4: tell them apart by the war's commit, meta.commit). The last
// entry is the live bot.

export const BOT_ROSTER = Object.freeze([
    {
        version: 1, name: 'Abel Bot', uid: 'bot:search-fast',
        from: '8f93d65', live: '2026-09-30 – 2026-10-01',
        runs: 'The search bot, one round ahead with a hand-written evaluation; the fast preset at first, the strong one from 0d777c2, then brood economy and brood hunting (2542008).',
    },
    {
        version: 2, name: 'Boaz Bot', uid: 'bot:search-strong-player',
        from: '2a473e9', live: '2026-10-01 – 2026-10-02',
        runs: 'Strong search predicting the player with a model fitted from their own wars (rules/bots/playerModel.js).',
    },
    {
        version: 3, name: 'Caleb Bot', uid: 'bot:search-strong-player-guard',
        from: '0b5bded', commits: ['0b5bded'], live: '2026-10-02',
        runs: 'Boaz, defending against what the player can legally strike with (rules/bots/threats.js), plus two worst-case futures.',
    },
    {
        version: 4, name: 'Deborah Bot', uid: 'bot:search-strong-player-guard',
        from: '51d2e25', commits: ['51d2e25'], live: '2026-10-02',
        runs: 'Caleb, covering its broods under construction and judging each plan by its own worst case.',
    },
    {
        version: 5, name: 'Ezra Bot', uid: 'bot:search-strong-player-learned',
        from: 'c6c7bb3', live: '2026-10-02',
        runs: 'Deborah, scoring plans by a learned win probability (rules/bots/valueNet.js, the first model) instead of the hand-written evaluation.',
    },
    {
        version: 6, name: 'Felix Bot', uid: 'bot:felix-v6',
        from: '7d6af0e', live: '2026-10-02 –',
        runs: 'Ezra with the second learned model (self-play and endgame drills), gap-closing deploys, and a player model refit on the player\'s own wars, brood-corridor strikes by target.',
    },
    {
        version: 7, name: 'Gary Bot', uid: 'bot:gary-v7',
        from: '254e808', live: 'not yet (ships with the progression prototype)',
        runs: 'Felix\'s search and settings on rules v8, scoring plans by a learned model retrained on v8 wars across arenas 1–6 (self-play that also meets Felix), with v8 features: kills still to take, yield per round, structures standing; its player model is refit on every tester\'s wars.',
    },
])

export const CURRENT_BOT = BOT_ROSTER[BOT_ROSTER.length - 1]

// The roster entry for a war's player-2 uid, or null when it isn't a bot.
// Given the war's commit (the archive's meta.commit), a uid two bots shared
// resolves to the one that ran that commit; otherwise to the later one.
export function botByUid(uid, commit = null) {
    const all = BOT_ROSTER.filter(b => b.uid === uid)
    if (commit) {
        const exact = all.find(b => (b.commits ?? []).some(c => String(commit).startsWith(c)))
        if (exact) return exact
    }
    return all[all.length - 1] ?? null
}

// The display name with its version: "Felix Bot v6".
export const botLabel = (bot) => `${bot.name} v${bot.version}`
